import {
  Container,
  ContainerLine,
  BlockProducts,
  Legend,
  Line,
  LineLegend,
  ButtonSeeAll,
  TitleButton,
  SubTitle,
  Description,
  BoxIcon,
  ContainerSearch,
  BoxButtons,
  TextLine,
} from "./styled";
import Body from "../../../../components/Body";
import SideBar from "../../../../components/SideBar";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../../components/Header";
import Title from "../../../../components/Title";
import { AiOutlineUpload } from "react-icons/ai";
import { BsEmojiSmile } from "react-icons/bs";
import Loading from "../../../../components/Loading";
import { translations } from "../../../../utils/language";
import LoadingLogo from "../../../../components/Loading-logo";

const Home = () => {
  const [page] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const [productSend, setProductSend] = useState();
  const [isAll, setIsAll] = useState();

  const dispatch = useDispatch();

  const sales = useSelector((state) => state.reducerSales);
  const emails = useSelector((state) => state.reducerEmails);
  const language = useSelector((state) => state.reducerLanguage);

  useEffect(() => {
    dispatch({
      type: "SAGA_LIST_SALES",
      payload: {
        perPage: perPage,
        page: page,
        code: "teste-01"
      },
    });
  }, [dispatch, perPage, page]);

  // useEffect(() => {
  //   dispatch({ type: "SAGA_GET_PLATFORMS_INTEGRATION" });
  // }, [dispatch]);

  return (
    <Body>
      <SideBar />
      <Container>
        <Header />
        {
          sales.loading ?
            <div style={{ display: "flex", flex: 1, justifyContent: "center", alignItems: "center" }}>
              <LoadingLogo />
            </div> :
            <ContainerLine>
              <BlockProducts>
                <Title marginBottom="16px">
                  {translations["Pedidos"][language.data]}
                </Title>
                <ContainerSearch>
                  <SubTitle>
                    {
                      translations["Veja os pedidos feitos nas loja integradas"][
                      language.data
                      ]
                    }
                  </SubTitle>
                </ContainerSearch>
                <table style={{ width: "100%" }}>
                  {sales.loading ? (
                    <Line>
                      <Loading />
                    </Line>
                  ) : (
                    <>
                      {sales?.data?.length === 0 ? (
                        <Line
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom: 12,
                          }}
                        >
                          <TextLine>
                            <BsEmojiSmile size={25} />{" "}
                            {
                              translations[
                              "Você ainda não recebeu nenhum pedido depois que integrou sua loja com o Dijital"
                              ][language.data]
                            }
                          </TextLine>
                        </Line>
                      ) : (
                        <>
                          <LineLegend>
                            <Legend>{translations["Data"][language.data]}</Legend>
                            <Legend>{translations["Pedido"][language.data]}</Legend>
                            <Legend>Plataforma</Legend>
                            <Legend>{translations["Ações"][language.data]}</Legend>
                          </LineLegend>
                          {sales?.data?.map((item) => (
                            <>
                              <Line style={{ alignItems: "center" }}>
                                <Description style={{ width: "30%" }}>
                                  {item.created_at.split("T")[0].replace(/-/g, "/")}
                                </Description>
                                <Description style={{ width: "30%" }}>
                                  {item.product_id}
                                </Description>
                                <Description style={{ width: "30%" }}>
                                  {item.platform}
                                </Description>
                                <Description style={{ width: "40%" }}>
                                  <BoxButtons
                                    onClick={() => {
                                      setProductSend(item.product_id);
                                      dispatch({
                                        type: "SAGA_RESEND_EMAIL",
                                        payload: {
                                          order_id: item.product_id,
                                          platform: item.platform,
                                          user_token: item.user_token,
                                        },
                                      });
                                    }}
                                  >
                                    <BoxIcon borderColor="#1B76FF">
                                      {emails.loading &&
                                        item.product_id === productSend ? (
                                        <Loading />
                                      ) : (
                                        <>
                                          <AiOutlineUpload
                                            size={20}
                                            color="#1B76FF"
                                            style={{ cursor: "pointer" }}
                                          />
                                          <label>Reenviar email</label>
                                        </>
                                      )}
                                    </BoxIcon>
                                  </BoxButtons>
                                </Description>
                              </Line>
                            </>
                          ))}
                        </>
                      )}
                    </>
                  )}
                </table>
                {!isAll && sales?.data?.length > 0 && (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: 10,
                    }}
                  >
                    <ButtonSeeAll
                      onClick={() => {
                        setPerPage(sales?.data?.total);
                        setIsAll(true);
                      }}
                    >
                      <TitleButton>
                        {translations["Ver tudo"][language.data]}
                      </TitleButton>
                    </ButtonSeeAll>
                  </div>
                )}
              </BlockProducts>
            </ContainerLine>        
        }

    </Container>
    </Body >
  );
};

export default Home;
